import { useAuth } from "@/lib/AuthProvider";
import { Navigate } from "react-router-dom";

/**
 * Protected route wrapper.
 *
 * Auth-only. We intentionally DO NOT auto-redirect authenticated users to
 * /onboarding — the app opens straight to /login → /home for a first-time
 * install. If a user wants to complete onboarding, they visit /onboarding
 * from a Profile prompt or link. This eliminates the "APK opens on
 * onboarding page" loop caused by stale WebView sessions.
 *
 * `requireOnboarded` prop is kept as a no-op for backwards-compat with the
 * dozens of routes that pass it — removing it would require touching every
 * <ProtectedRoute> caller in App.js.
 */
export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p className="eyebrow pulse-soft">Loading</p>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
